var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import ClientService from '../../../api/ClientService';
import { Loading } from 'element-ui';
import Pagination from "../../../common/components/Pagination.vue";
var RouteManageDialog = (function (_super) {
    __extends(RouteManageDialog, _super);
    function RouteManageDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.searchKeyword = '';
        _this.clientDetail = '';
        _this.dialogVisible = false;
        _this.dialogType = 'add';
        _this.formData = {
            route_id: '',
            route_name: ''
        };
        _this.formRules = {
            route_name: [
                { required: true, message: '请输入线路名称', trigger: 'blur' },
                { max: 50, message: '线路名称最多50个字符', trigger: 'blur' }
            ]
        };
        return _this;
    }
    RouteManageDialog.prototype.created = function () {
        this.service = ClientService.getInstance();
    };
    RouteManageDialog.prototype.mounted = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.getRouteList();
        });
    };
    RouteManageDialog.prototype.getRouteList = function (pager) {
        var _this = this;
        var loading = Loading.service({
            target: this.$el,
            text: '加载中...'
        });
        var params = __assign({ keyword: this.searchKeyword, is_page: 1 }, pager);
        this.service.getRouteList(params).then(function (res) {
            console.log('分拣线路列表响应:', res);
            if (res.data.success) {
                _this.listData = Array.isArray(res.data.data.data) ? res.data.data.data : [];
                _this.total = res.data.data.total || 0;
                console.log('分拣线路列表数据:', _this.listData);
            }
            else {
                _this.$message.error(res.data.message || '获取线路列表失败');
            }
        }).catch(function (error) {
            console.error('获取线路列表失败:', error);
            _this.$message.error('获取线路列表失败');
        }).finally(function () {
            loading.close();
        });
    };
    RouteManageDialog.prototype.pageChange = function (pager) {
        this.getRouteList(pager);
    };
    RouteManageDialog.prototype.search = function () {
        this.getRouteList();
    };
    RouteManageDialog.prototype.openAddDialog = function () {
        this.dialogType = 'add';
        this.formData = {
            route_id: '',
            route_name: ''
        };
        this.dialogVisible = true;
    };
    RouteManageDialog.prototype.openEditDialog = function (row) {
        this.dialogType = 'edit';
        this.formData = {
            route_id: row.route_id,
            route_name: row.route_name
        };
        this.dialogVisible = true;
    };
    RouteManageDialog.prototype.saveForm = function () {
        var _this = this;
        this.$refs.form.validate(function (valid) {
            if (valid) {
                var params = {
                    route_name: _this.formData.route_name
                };
                var promise = void 0;
                if (_this.dialogType === 'add') {
                    promise = _this.service.createRoute(params);
                }
                else {
                    promise = _this.service.updateRoute(__assign({}, params, { route_id: _this.formData.route_id }));
                }
                promise.then(function (res) {
                    if (res.data.success) {
                        _this.$message.success('保存成功！');
                        _this.dialogVisible = false;
                        _this.getRouteList(_this.$refs.pagination.pager);
                        _this.$emit('refresh');
                    }
                    else {
                        _this.$message.error(res.data.message || '保存失败');
                    }
                }).catch(function (error) {
                    console.error('保存失败:', error);
                    _this.$message.error('保存失败');
                });
            }
        });
    };
    RouteManageDialog.prototype.deleteItem = function (row) {
        var _this = this;
        this.$confirm('确定要删除该线路吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function () {
            _this.service.deleteRoute({
                route_id: row.route_id
            }).then(function (res) {
                if (res.data.success) {
                    _this.$message.success('删除成功！');
                    _this.getRouteList(_this.$refs.pagination.pager);
                    _this.$emit('refresh');
                }
                else {
                    _this.$message.error(res.data.message || '删除失败');
                }
            }).catch(function (error) {
                console.error('删除失败:', error);
                _this.$message.error('删除失败');
            });
        }).catch(function () {
        });
    };
    RouteManageDialog.prototype.onShow = function (args) {
        console.log('分拣线路管理', args);
        this.clientDetail = args;
        if (this.clientDetail && this.clientDetail.business_id) {
            this.getRouteList();
        }
    };
    RouteManageDialog.prototype.onHide = function () {
        this.listData = [];
        this.total = 0;
        this.searchKeyword = '';
        this.dialogVisible = false;
    };
    RouteManageDialog = __decorate([
        Component({
            components: {
                'pagination': Pagination
            }
        })
    ], RouteManageDialog);
    return RouteManageDialog;
}(VueDialog));
export default RouteManageDialog;
